import { render, staticRenderFns } from "./position-alarm-popover.vue?vue&type=template&id=68ffb220&scoped=true&"
import script from "./position-alarm-popover.vue?vue&type=script&lang=js&"
export * from "./position-alarm-popover.vue?vue&type=script&lang=js&"
import style0 from "./position-alarm-popover.vue?vue&type=style&index=0&id=68ffb220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ffb220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ffb220')) {
      api.createRecord('68ffb220', component.options)
    } else {
      api.reload('68ffb220', component.options)
    }
    module.hot.accept("./position-alarm-popover.vue?vue&type=template&id=68ffb220&scoped=true&", function () {
      api.rerender('68ffb220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/data-table/position-alarm-popover.vue"
export default component.exports